export default {
  // 专属管家页面
  'pages.housekeeper.title': '专属管家',
  'pages.housekeeper.subTitle': '管理小区内的专属管家信息',
  'pages.housekeeper.breadcrumb.person': '人员管理',
  'pages.housekeeper.breadcrumb.housekeeper': '专属管家',

  // 语言选项
  'pages.housekeeper.lang.chinese': '中文',
  'pages.housekeeper.lang.english': '英文',

  // 表格相关
  'pages.housekeeper.table.title': '专属管家列表',
  'pages.housekeeper.table.headerTitle': '专属管家列表',
  'pages.housekeeper.table.button.add': '新增专属管家',
  'pages.housekeeper.table.button.edit': '编辑',
  'pages.housekeeper.table.button.view': '查看',
  'pages.housekeeper.table.button.enable': '启用',
  'pages.housekeeper.table.button.disable': '停用',

  // 表格列标题
  'pages.housekeeper.table.columns.avatar': '头像',
  'pages.housekeeper.table.columns.name': '姓名',
  'pages.housekeeper.table.columns.position': '职位',
  'pages.housekeeper.table.columns.phone': '手机号',
  'pages.housekeeper.table.columns.email': '邮箱',
  'pages.housekeeper.table.columns.serviceTime': '服务时间',
  'pages.housekeeper.table.columns.status': '状态',
  'pages.housekeeper.table.columns.createdTime': '创建时间',
  'pages.housekeeper.table.columns.operations': '操作',

  // 状态标签
  'pages.housekeeper.status.notServiced': '未服务',
  'pages.housekeeper.status.servicing': '服务中',
  'pages.housekeeper.status.disabled': '已停用',

  // 表单相关
  'pages.housekeeper.form.title.edit': '编辑专属管家',
  'pages.housekeeper.form.title.add': '新增专属管家',
  'pages.housekeeper.form.label.name': '姓名',
  'pages.housekeeper.form.label.avatar': '头像',
  'pages.housekeeper.form.label.position': '职位',
  'pages.housekeeper.form.label.phone': '手机号',
  'pages.housekeeper.form.label.email': '邮箱',
  'pages.housekeeper.form.label.serviceTime': '服务时间',
  'pages.housekeeper.form.label.status': '状态',
  'pages.housekeeper.form.label.description': '描述',

  // 表单占位符
  'pages.housekeeper.form.placeholder.name': '请输入姓名',
  'pages.housekeeper.form.placeholder.position': '请输入职位',
  'pages.housekeeper.form.placeholder.phone': '请输入手机号',
  'pages.housekeeper.form.placeholder.email': '请输入邮箱',
  'pages.housekeeper.form.placeholder.serviceTime': '请输入服务时间',
  'pages.housekeeper.form.placeholder.status': '请选择状态',
  'pages.housekeeper.form.placeholder.description': '请输入描述信息',

  // 表单验证
  'pages.housekeeper.form.validation.name.required': '请输入姓名',
  'pages.housekeeper.form.validation.status.required': '请选择状态',
  'pages.housekeeper.form.validation.email.pattern': '请输入正确的邮箱格式',

  // 状态选项
  'pages.housekeeper.form.status.notServiced': '未服务',
  'pages.housekeeper.form.status.servicing': '服务中',
  'pages.housekeeper.form.status.disabled': '已停用',

  // 头像上传相关
  'pages.housekeeper.avatar.upload.tab.local': '本地上传',
  'pages.housekeeper.avatar.upload.tab.url': '头像URL',
  'pages.housekeeper.avatar.upload.placeholder.url': '请输入头像URL地址',
  'pages.housekeeper.avatar.upload.hint.drag': '拖拽或点击上传头像',
  'pages.housekeeper.avatar.upload.hint.uploading': '上传中...',
  'pages.housekeeper.avatar.upload.hint.change': '点击或拖拽图片到此处更换',
  'pages.housekeeper.avatar.upload.hint.format': '支持JPG/PNG/GIF/WEBP格式，最大20MB',
  'pages.housekeeper.avatar.upload.hint.size': '推荐尺寸：正方形头像，图片将显示为完整URL，但只存储相对路径到数据库',
  'pages.housekeeper.avatar.upload.error.type': '只能上传图片文件!',
  'pages.housekeeper.avatar.upload.error.size': '图片大小不能超过20MB!',
  'pages.housekeeper.avatar.upload.success': '头像上传成功',
  'pages.housekeeper.avatar.upload.error': '头像上传失败',

  // 消息提示
  'pages.housekeeper.message.disable.success': '停用成功',
  'pages.housekeeper.message.disable.error': '停用失败',
  'pages.housekeeper.message.enable.success': '启用成功',
  'pages.housekeeper.message.enable.error': '启用失败',
  'pages.housekeeper.message.detail.error': '获取详情失败',
  'pages.housekeeper.message.update.success': '更新成功',
  'pages.housekeeper.message.update.error': '更新失败',
  'pages.housekeeper.message.create.success': '创建成功',
  'pages.housekeeper.message.create.error': '创建失败',
  'pages.housekeeper.message.operation.error': '操作失败',

  // 确认对话框
  'pages.housekeeper.confirm.enable.title': '确定要启用该管家吗？',
  'pages.housekeeper.confirm.enable.description': '启用后该管家将恢复正常使用',
  'pages.housekeeper.confirm.disable.title': '确定要停用该管家吗？',
  'pages.housekeeper.confirm.disable.description': '停用后该管家将无法正常使用',
  'pages.housekeeper.confirm.okText': '确定',
  'pages.housekeeper.confirm.cancelText': '取消',

  // 详情模态框
  'pages.housekeeper.detail.title': '专属管家详情',
  'pages.housekeeper.detail.button.close': '关闭',
  'pages.housekeeper.detail.section.basic': '基本信息',
  'pages.housekeeper.detail.section.detail': '详细信息',
  'pages.housekeeper.detail.label.position': '职位',
  'pages.housekeeper.detail.label.serviceTime': '服务时间',
  'pages.housekeeper.detail.label.phone': '手机号',
  'pages.housekeeper.detail.label.email': '邮箱',
  'pages.housekeeper.detail.label.description': '描述',
  'pages.housekeeper.detail.label.createdTime': '创建时间',
  'pages.housekeeper.detail.label.updatedTime': '更新时间',

  // 其他文本
  'pages.housekeeper.text.dash': '-',
};
